import {useEffect, useState} from 'react'
import TableRows from "./TableRows"
import 'react-bootstrap-typeahead/css/Typeahead.css';
const AddDeleteTableRows= (props)=>{
    const [rowsData, setRowsData] = useState([{
      name:'',
      qty:'',
      unit:'Pcs',  
      price:'',  
      discount:0,
      amount:'',  
      gst:5  
  }]);

    const [fabrics, setFabrics] = useState(props.fabrics);
    const [subtotal, setSubtotal] = useState(0); 
    const [gst, setGst] = useState(12); 
    const [totalAmount, setTotalAmount] = useState(0); 
    const [deliveryAdd, setDeliveryAdd] = useState("");
    const [delId, setDelId] = useState("");
    const [notes, setNotes] = useState("");
    const addTableRows = (e)=>{
      e.preventDefault();
        const rowsInput={
            name:'',
            qty:'',
            unit:'Pcs',  
            price:'',  
            discount:0,
            amount:'',  
            gst:5  
        } 
        setRowsData([...rowsData, rowsInput])
    }
   const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        //console.log(rows)
        //console.log(index)
        rows.splice(index, 1);
        setRowsData(rows);
   }



   
const handleChange = (index, evnt)=>{
  const { name, value } = evnt.target;
  const rowsInput = [...rowsData];

  /* if change fabric dropdown then fetch fabric details and set price */
  if(evnt.target.name=='name'){
    var fabric_id_price = evnt.target.value.split('#');
    rowsInput[index][name] = fabric_id_price[0];
    rowsInput[index]['price'] = fabric_id_price[1];
  }else{
    rowsInput[index][name] = value;
  }

  let amount_total = rowsInput[index]['qty']*rowsInput[index]['price'];
  let discount = rowsInput[index]['discount'];
  let discount_amount = ((amount_total*discount)/100);
  rowsInput[index]['amount'] = (amount_total-discount_amount);
  
  if(rowsInput.length>0){
     let price_arr = rowsInput.map(el=>el.amount); 
     let sum = price_arr.reduce((accumulator, currentvalue)=>{
        return accumulator+Number(currentvalue);
     },0)
    
    setSubtotal(sum);
    setTotalAmount(sum);
  }
  props.handleRowdata(rowsData);
  setRowsData(rowsInput);
}

useEffect(()=>{
  setFabrics(props.fabrics);
})

useEffect(()=>{
  handleAddress(0)
},[]);

useEffect(()=>{
  props.handlePodata({subtotal,gst,totalAmount,delId,deliveryAdd,notes});
},[subtotal,gst,totalAmount,deliveryAdd,notes])

const handleAddress = (addId)=>{
  setDelId(addId);
  let AddArr = [{"1":"A-14, Narayana \r industrial  area \r Delhi-110028","2":"A-44 Back side, Narayana \r industrial  area \r Delhi-110028"}];
  if(addId){
    const delAdd =AddArr[0][addId]; 
    setDeliveryAdd(delAdd);
  }else{
    setDeliveryAdd("");
  }
}


    return(
               <>
                <div className="row">
                <div className='col-md-12'>
                <div class="table-responsive-box box-table-responsive">
                  <table className="table table-hover table-sticky">
                      <thead>
                        <tr>
                          <th scope="col">Kali/Dupatta</th>
                          <th scope="col" className='small-table-col'>Quantity</th>
                          <th scope="col" className='small-table-col'>Unit</th>
                          <th scope="col" className='medium-table-col'>Price</th>
                          <th scope="col" className='small-table-col'>Dis %</th>
                          <th scope="col" className='medium-table-col'>Amount INR</th>
                          <th scope="col" className='small-table-col'>GST %</th>
                          <th scope="col" className='medium-table-col'>Action</th>
                        </tr>
                      </thead>
                    <tbody>
                    <TableRows rowsData={rowsData} deleteTableRows={deleteTableRows} handleChange={handleChange} handleFabrics={fabrics}/>
                    </tbody> 
                  </table>
                  </div>
                  </div>
                  </div>

                  <div className="row bottom-divider">
                    <div className='col-md-4   mb-3'> 
                      <button className="btn btn-success" onClick={addTableRows} >+ Add Row</button>
                    </div>
                    <div className='col-md-8 float-end   mb-3'> 
                      <p>Subtotal: {subtotal}</p>
                      <p>GST: {gst}</p>
                      <p>Total: {totalAmount}</p>
                    </div>
                    </div>

                    <div className="row">
                    <div className='col-md-4 mb-3'>
                    <label className="form-label">Delivery Address*</label>
                    <select required className='form-control mb-3' name="del_id" onChange={(e)=>{handleAddress(e.target.value)}}>
                      <option value={""}>--Select Delivery Address--</option>
                      <option value={1}> A-14 </option>
                      <option value={2}> A-44 </option>
                    </select>

                    <textarea required cols={10} rows={3} style={{height:'85px'}} className='form-control' name='del_address'  value={deliveryAdd} onChange={(e)=>setDeliveryAdd(e.target.value)}/>
                    </div>

                    <div className='col-md-8 mb-3'>
                    <label className="form-label">Notes</label>
                    <textarea cols={15} rows={3} style={{height:"135px"}} className='form-control' name='po_notes' value={notes} onChange={(e)=>setNotes(e.target.value)}/>
                    </div>
                  </div>

                  </>
                
           
    )
}
export default AddDeleteTableRows